var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Override = function Override(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'override icon'
      ),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M14 8v1.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5V8zm-.5-8h-12C.673 0 0 .673 0 1.5v8c0 .827.673 1.5 1.5 1.5H7v2H5v1h5v-1H8v-2h5.5c.827 0 1.5-.673 1.5-1.5v-8c0-.827-.673-1.5-1.5-1.5z',
          fill: 'currentColor' }),
        React.createElement('path', { stroke: 'currentColor', d: 'M5 5.5L7 8l4-5' })
      )
    )
  );
};
/*eslint-enable */

export default Override;
//# sourceMappingURL=Override.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Override.js